import React, { useContext } from "react";
import Link from "./Link";

import { IoMdHome } from "react-icons/io"
import { MdFavorite } from "react-icons/md"
import { FaUser } from "react-icons/fa"

import { RiUserFollowFill } from "react-icons/ri";
import { AiFillSetting } from "react-icons/ai"
import { LinkItems } from "../Types/sidebar";

import { v4 as uuidv4 } from 'uuid';
import { Box, Flex } from "@chakra-ui/layout";
import LoggedOut from "./LoggedOut";
import { TokenContext, UserContext } from "../App";
import { useNavigate } from "react-router-dom";
import { useToast } from '@chakra-ui/react'

import { Button } from "@chakra-ui/react";

import "./Navbar.css"

let links: LinkItems = [
    {name: "Home", icon: IoMdHome},
    {name: "Settings", icon: AiFillSetting},
]

const f = {name: "Following", icon: RiUserFollowFill}
const l = {name: "Liked", icon: MdFavorite}



const Navbar = () => {
    // @ts-ignore
    const {user, setUser} = useContext(UserContext)
    const {token, setToken} = useContext(TokenContext)
    let navigate = useNavigate()
    const toast = useToast()

    let ans = []
    if(user !== null) {
        ans = [...links, f, l]
    }
    else {
        ans = [...links]
    }

    const handleLogin = () => {
        navigate("/login");
    }

    const handleLogout = () => {
        navigate("/")
        fetch('https://fullstacktweeterclone.herokuapp.com/auth/logout/', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${token}`
            }
        })
        .then(res => {
            setToken(null)
            setUser(null)
            toast({
            position: 'top-right',
            title: 'Logout Success',
            description: "You have successfully logged out",
            status: 'success',
            duration: 9000,
            isClosable: true,
        })
        })
    }

    const renderLinks = ans.map((link) => <Link key={uuidv4()} name={link.name} icon={link.icon}></Link>)

    return (
        <Flex className="navbar-flex-container">
            <Box className="navbar-container">
                <Box className="navbar-link">  
                    {renderLinks}
                </Box>
                <Box className="logout-button-container">
                    {user === null ? <Button className="logout-button" onClick={handleLogin}>Login</Button>: <Button className="logout-button" onClick={handleLogout}>Logout</Button>}
                </Box>
            </Box>
            <Box className="inflow-box"></Box>
        </Flex>
    )
}

export default Navbar
